<div class="container display-layout-column layout-gap-60">
  <div class="display-layout-column layout-gap-15">
    <div [formGroup]="assignGroup">
      <mat-form-field appearance="fill">
        <mat-label>Request ID</mat-label>
        <input formControlName="requestId" matInput type="text" />

        @if (assignGroup.controls['requestId'].hasError('required')) {
          <mat-error>RequestID is required</mat-error>
        }

        @if (assignGroup.controls['requestId'].hasError('minlength')) {
          <mat-error>RequestID is <b>36</b> characters
        long</mat-error>
      }

      @if (assignGroup.controls['requestId'].hasError('maxlength')) {
        <mat-error>RequestID is <b>36</b> characters
      long</mat-error>
    }
  </mat-form-field>
</div>

<div>
  <div class="row layout-gap-10">
    <div><b>From:</b> {{ data.message.from?.emailAddress?.address }}</div>
    <div><b>Date:</b> {{ data.message.receivedDateTime | date: "medium" }}</div>
  </div>
  <div><b>Subject:</b> {{ data.message.subject }}</div>
</div>

<div>
  <div><b>Message:</b></div>

  <div [innerHTML]="data.message.body?.content | sanitizehtml"></div>
</div>
</div>

<div class="display-layout-column">
  <div class="display-layout-row justify-content-end">
    <button mat-button (click)="close()">Close</button>
    <button mat-stroked-button (click)="assignMessage()" [disabled]="assignGroup.invalid">
      <mat-icon>save</mat-icon>Save
    </button>
  </div>
</div>
</div>
